import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGrid, gridNumberComparator } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { parseMillisToString, parseMomentToMillis } from '../dao';
import { useDispatch, useSelector } from 'react-redux';
import { selectExperiments, setCurrentExperiment } from '../store/ExperimentSlice';

function safeParseInt(val) {
    return !isNaN(val) ? parseInt(val) : 0
}

const columns = [
    { field: 'name', headerName: 'Experiment', flex: 2 },
    { field: 'incubator', headerName: 'Laptop', flex: 1 },
    {
        field: 'startDate', headerName: 'Start Date', flex: 2,
        valueFormatter: (endDate) => {
            return !isNaN(endDate) ? parseMillisToString(endDate) : "";
        },
        sortComparator: (v1, v2) => {
            return gridNumberComparator(safeParseInt(v1), safeParseInt(v2))
        }
    },
    {
        field: 'endDate', headerName: 'End Date', flex: 2,
        valueFormatter: (endDate) => {
            return !isNaN(endDate) ? parseMillisToString(endDate) : "";
        },
        sortComparator: (v1, v2) => {
            return gridNumberComparator(safeParseInt(v1), safeParseInt(v2))
        }
    },
    {
        field: 'status', headerName: 'Status', flex: 1,
    },
]

function Title() {
    return (
        <Box style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "10px" }}>
            <Typography variant="h5">All Experiments</Typography>
        </Box>
    )
}

function ExperimentViewTable() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const experiments = useSelector(selectExperiments)


    const accessExperiment = (experiment) => {
        navigate(`/access/${experiment.timestamp}`);
    }

    const handleRowClick = (params) => {
        dispatch(setCurrentExperiment(params.row.timestamp))
        accessExperiment(params.row)
    };

    return (
        <DataGrid
            sx={{ marginBottom: 6 }}
            rows={experiments}
            columns={columns}
            getRowId={(row) => row.timestamp}
            onRowClick={handleRowClick}
            slots={{ toolbar: Title }}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 5,
                    },
                },
                sorting: {
                    sortModel: [{ field: 'startDate', sort: 'desc' }],
                },
            }}
            pageSizeOptions={[5, 10, 15]}
            autoHeight={true}
        />
    )
}

export default ExperimentViewTable;